import { Api } from '../typings/api';

const hasExcludePatterns = (patterns: string[] | undefined): patterns is string[] =>
	!!patterns && patterns.length > 0;

export const resolveResourceZipExcludePatterns = (
	config: Api.Config,
	driveItemId: number,
): string[] | undefined => {
	const resourceZipExclude = config.offlineDownload
		&& config.offlineDownload.resourceZipExclude;

	if (!resourceZipExclude || resourceZipExclude.enabled === false) {
		return undefined;
	}

	const rules = resourceZipExclude.rules || [];

	for (let i = 0; i < rules.length; i += 1) {
		const rule = rules[i];

		if (rule.ids && rule.ids.includes(driveItemId)) {
			return hasExcludePatterns(rule.exclude) ? rule.exclude : undefined;
		}
	}

	return hasExcludePatterns(resourceZipExclude.defaultExclude)
		? resourceZipExclude.defaultExclude
		: undefined;
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/resourceZipExclude.ts